import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { TournamentsResponse } from '../../models/api/responses/tournaments.response';
import { AllTournamentsService } from '../../services/all-tournaments.service';
import { AllTournamentsActions } from '../actions/action-types.action';
import { BadResponseWithError } from '../../../shared/models/bad-response-with-error.interface';

@Injectable({ providedIn: 'root' })
export class AllTournamentsEffect {
    fetchAllTournaments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AllTournamentsActions.fetchAllTournaments),
            switchMap(
                ({
                    payload: {
                        patchExistingTournaments,
                        type,
                        page,
                        pageSize,
                        filters = {},
                    },
                }) =>
                    this.allTournamentsService
                        .getAllTournaments(page, filters, pageSize)
                        .pipe(
                            map((response: TournamentsResponse) =>
                                AllTournamentsActions.fetchAllTournamentsSuccess(
                                    {
                                        payload: {
                                            type,
                                            patchExistingTournaments,
                                            response,
                                        },
                                    }
                                )
                            ),
                            catchError((response: BadResponseWithError) =>
                                of(
                                    AllTournamentsActions.fetchAllTournamentsFailure(
                                        {
                                            payload: response,
                                        }
                                    )
                                )
                            )
                        )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private allTournamentsService: AllTournamentsService
    ) {}
}
